import dayjs from 'dayjs';
import { pathOr } from 'ramda';
import { consoleWarningStyle } from './constants';

// Config
export const getPosApiUrl = (state) =>
  pathOr('', ['config', 'posApiUrl'], state);

// Token and Local Storage methods
export const getAccessToken = () =>
  JSON.parse(localStorage.getItem('okta-token-storage'))?.accessToken
    ?.accessToken ?? '';
export const getRefreshToken = () =>
  JSON.parse(localStorage.getItem('okta-token-storage'))?.refreshToken
    ?.refreshToken ?? '';

export const getTerminalSessionId = () =>
  JSON.parse(localStorage.getItem('terminalSession'))?.terminalSession?.id ??
  null;

export const getDecodedAccessToken = () => {
  const token = getAccessToken();
  if (!token) {
    return '';
  }
  const base64Url = token.split('.')[1];
  const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
  const jsonPayload = decodeURIComponent(
    window
      .atob(base64)
      .split('')
      .map(function (c) {
        return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
      })
      .join(''),
  );
  return JSON.parse(jsonPayload);
};

export const isTokenExpired = () => {
  const token = getDecodedAccessToken();
  if (!token) {
    console.warn(
      '%cWarning: No auth token found.',
      `background-color: ${consoleWarningStyle}`,
    );
  }
  const { exp: tokenExpirationTime } = token;
  const tokenExpDayJS = dayjs.unix(tokenExpirationTime);
  const nowDayJS = dayjs();
  return nowDayJS.isAfter(tokenExpDayJS) ? true : false;
};

export const clearLocalStorageSession = () => {
  localStorage.removeItem('terminalSession');
  localStorage.removeItem('session');
};
